import React from 'react';

import { useSelector } from 'react-redux';

import { EventPreview } from './EventPreview';
import st from './EventRoll.module.sass';
import { Settings } from './Settings';
import { selectLatestEvents } from '../selectors.js';
import type { SidebarName } from './Settings';

export { EVENT_ROLL_SIDEBARS } from './Settings';
export type { SidebarName } from './Settings';

interface EventRollProps {
  activeSidebar: SidebarName | null;
  onToggleSidebar: (name: SidebarName) => void;
}

export function EventRoll({
  activeSidebar,
  onToggleSidebar,
}: EventRollProps): React.JSX.Element {
  const eventRoll = useSelector(selectLatestEvents);

  return (
    <div className={st.Root}>
      <Settings
        activeSidebar={activeSidebar}
        onToggleSidebar={onToggleSidebar}
      />
      <div className={st.List}>
        {eventRoll?.data?.map((event) => (
          <EventPreview
            event={event}
            key={event?.event_id ?? event?.event?.event_id}
          />
        ))}
      </div>
    </div>
  );
}
